import { render, staticRenderFns } from "./benefit.vue?vue&type=template&id=3d880dfe"
import script from "./benefit.vue?vue&type=script&lang=js"
export * from "./benefit.vue?vue&type=script&lang=js"
import style0 from "./benefit.vue?vue&type=style&index=0&id=3d880dfe&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d880dfe')) {
      api.createRecord('3d880dfe', component.options)
    } else {
      api.reload('3d880dfe', component.options)
    }
    module.hot.accept("./benefit.vue?vue&type=template&id=3d880dfe", function () {
      api.rerender('3d880dfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/treeties/detail/benefit.vue"
export default component.exports